<template>
  <div v-if="currentFilter" class="pa-2">
    <div>
      <div>
        {{ $t('sort_by') }}
        <DropdownMenu
          v-model="currentFilter.sortBy"
          :outtericon="true"
          :options="optionsSort"
          :text-value="'value'"
          :text-label="'label'"
          @change="onSearch"
        >
          <span style="font-weight: bold">{{ sortByLabel }}</span>
        </DropdownMenu>
      </div>
    </div>
    <v-divider class="my-2"></v-divider>
    <div>{{ $t('channel') }}</div>
    <div>
      <v-radio-group v-model="currentFilter.channel" class="mt-0" row @change="onSearch">
        <v-radio :label="$t('all')" value="all" color="primary"></v-radio>
        <template v-for="channel in conversationSocialChannelOptions">
          <v-radio
            :key="channel.fullValueForUse"
            :label="channel.text"
            :value="channel.fullValueForUse"
            color="primary"
          ></v-radio>
        </template>
      </v-radio-group>
    </div>
    <div>{{ $t('priority') }}</div>
    <div>
      <v-combobox
        v-model="currentFilter.priority"
        outline
        single-line
        chips
        :placeholder="$t('priority')"
        :items="priorityOptions"
        multiple
        item-text="label"
        item-value="value"
        :return-object="false"
        hide-details
        @input="onSearch"
      >
      </v-combobox>
    </div>

    <div class="mt-3">{{ $t('status') }}</div>
    <div>
      <v-combobox
        v-model="filterStatus"
        outline
        single-line
        chips
        :placeholder="$t('status')"
        :items="statusOptions"
        multiple
        item-text="label"
        item-value="value"
        hide-details
        @input="onSearch"
      >
      </v-combobox>
    </div>

    <template v-if="wrapUpOptions">
      <div class="mt-3">{{ $t('wrap_up') }}</div>
      <div>
        <v-combobox
          v-model="currentFilter.wrap_up"
          outline
          single-line
          chips
          :placeholder="$t('wrap_up')"
          :items="wrapUpOptions"
          multiple
          item-text="label"
          item-value="value"
          hide-details
          @input="onSearch"
        >
        </v-combobox>
      </div>
    </template>
  </div>
</template>

<script>
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import { priorityOptions } from '@/constants/ticket3/ticketConstant'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page.js'

export default {
  components: {
    DropdownMenu
  },
  props: ['filter'],
  data() {
    return {
      currentFilter: undefined,
      priorityOptions: priorityOptions,
      optionsSort: [
        { label: this.$t('assign_ticket_timestamp'), value: 'assign_ticket_timestamp' },
        { label: this.$t('due_by_time'), value: 'duedate' },
        { label: this.$t('created_date'), value: 'starttime' },
        { label: this.$t('priority'), value: 'priority' }
      ],
      loading: false,
      wrapUpOptions: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCustomerSupportService', 'customerStatusOptions']),
    sortByLabel() {
      const sortBy =
        this.optionsSort && this.optionsSort.find((el) => el.value == this.filter.sortBy)
      return sortBy ? sortBy.label : null
    },
    statusOptions() {
      if (this.isCustomerSupportService) {
        return this.customerStatusOptions
      } else {
        const status = this.$store.getters.ticketStatusOptions
        if ([PAGE_GROUP.EMMA_CLINIC].includes(this.selectedBot.page_group)) {
          const statusFilter = status.filter((item) =>
            ['pending', 'answered', 'cancelled', 'cancelled by customer'].includes(item.value)
          )
          const index = 2
          const statusOption = [
            ...statusFilter.slice(0, index),
            { label: 'closed', value: 'closed', color: '#e0e0e0' },
            ...statusFilter.slice(index)
          ]
          return statusOption.map((el) => {
            return { label: this.toCapitalCase(el.label), value: el.value }
          })
        } else {
          return status.map((el) => {
            return { label: this.toCapitalCase(el.label), value: el.value }
          })
        }
      }
    },
    filterStatus: {
      get() {
        const status = this.filter && this.filter.status ? this.filter.status : []
        return this.statusOptions.filter((el) => status.includes(el.value))
      },
      set(value) {
        this.currentFilter.status = value ? value.map((el) => el.value.toLowerCase()) : []
      }
    }
  },
  watch: {
    filter: {
      handler(val) {
        this.currentFilter = val
      },
      deep: true
    }
  },
  mounted() {
    this.currentFilter = this.filter
    this.getWrapUp()
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.filter)
    },
    async getWrapUp() {
      this.loading = true
      try {
        const response = await this.$store.dispatch('loadWrapUp', {
          page_id: this.selectedBot.pageid
        })
        if (response) {
          this.wrapUpOptions = response.data
            ? response.data.map((el) => ({
                label: el.wrap_up,
                value: el.wrap_up
              }))
            : []
          this.total = +response.total || 0
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketFilter.vue